export default "__VITE_ASSET__DLF5INNZ__"